import { defineComponent as _defineComponent } from 'vue'
import {
  AcceptedFileExtensions,
  AcceptedFileTypes,
  JPEG,
  JPG,
  maxFileSize,
  PNG,
} from '@/utils/constants'
import { last } from 'lodash'
import { parseDataUrlMimeType } from '@/utils/data-url'
import { computed, reactive, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FileAttachmentField',
  props: {
    errorSchema: null,
    formData: null,
    params: null,
    rootSchema: null,
    schema: null,
    title: null,
    description: null,
    uiSchema: null,
    disabled: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({ (e: 'change', value: string | null) }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  errorSchema?: { errors?: string[] | null } | null
  formData?: string | null
  params: never | null
  rootSchema: never
  schema: never
  title: string | null
  description?: string | null
  uiSchema: never
  disabled: boolean
}



const data = reactive<{ uploading: boolean }>({ uploading: false })

const errorMessages = computed(() => props.errorSchema?.errors ?? [])

const dataUrlProps = computed(() => {
  if (props.formData) {
    return parseDataUrlMimeType(props.formData)
  }
  return null
})

const fileName = computed(() => {
  if (dataUrlProps.value) {
    return decodeURIComponent(
      dataUrlProps.value?.parameters?.get('download') ?? 'unknown'
    )
  }

  return decodeURIComponent(last(new URL(props.formData!).pathname.split('/'))!)
})

const isImage = computed<boolean>(
  () =>
    dataUrlProps.value?.type === 'image' ||
    [PNG.extension, JPEG.extension, JPG.extension].some(
      (ext) => urlFileExtension.value === ext
    )
)

const urlFileExtension = computed(() =>
  new URL(props.formData!).pathname.split('.').pop()
)

const uploader = ref<HTMLInputElement | null>(null)

const clickAddAttachment = () => {
  uploader.value?.click()
}



const clickRemoveAttachment = () => emit('change', null)

const onFilesSelected = (e: InputEvent) => {
  if ((e.target as HTMLInputElement).files.length === 1) {
    const file = (e.target as HTMLInputElement).files![0]
    handleFile(file)
  }
}

const handleFile = (file: File) => {
  data.uploading = true
  const reader = new FileReader()
  reader.onloadend = function () {
    // convert image file to base64 string
    let dataUrl = reader.result
    const index = (dataUrl as string).indexOf(';')

    dataUrl = `${dataUrl.slice(0, index + 1)}download=${encodeURIComponent(
      file.name
    )}${dataUrl.slice(index)}`

    data.uploading = false
    emit('change', dataUrl)
  }

  reader.readAsDataURL(file)

  uploader.value!.value = ''
}

/// Todo use this to limit file selection
const isFileValid = (file) => {
  if (!AcceptedFileTypes.includes(file.type)) {
    this.unsupportedFileTypeSelected()
    return false
  } else if (this.convertBinaryBytesToMegaBytes(file.size) > maxFileSize) {
    this.maximumFileSizeExceeded()
    return false
  } else {
    return true
  }
}

const fileExtensionRestrictions = () =>
  AcceptedFileExtensions.map((ext) => '.' + ext).join(', ')

const documentClicked = () => {
  const tag = document.createElement('a')
  tag.download = fileName.value
  tag.href = props.formData!
  tag.click()
}

const imageClicked = () => {
  if (dataUrlProps.value) {
    const image = new Image()
    image.src = props.formData!

    const newWindow = window.open('')
    newWindow.document.write(image.outerHTML)
  } else {
    window.open(props.formData!)
  }
}

return { __sfc: true,props, data, errorMessages, dataUrlProps, fileName, isImage, urlFileExtension, uploader, clickAddAttachment, emit, clickRemoveAttachment, onFilesSelected, handleFile, isFileValid, fileExtensionRestrictions, documentClicked, imageClicked }
}

})